import { Component, Mixins } from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Props from './props';

@Component({
    components: {},
})

/**
 * @name SectionTitle
 */
export default class SectionTitle extends Mixins(HybridMixin, Props) {
    /**
     * Return the Link tag
     *
     * @returns {string}
     */
    get linkType(): string {
        return typeof this.link === 'string' ? 'a' : 'router-link';
    }

    /**
     * Return the border color of the title
     * If titleLine is true
     *
     * @returns {Array<string>}
     */
    get titleClass(): Array<string> {
        const cls: Array<string> = [];
        if (this.titleLine) {
            cls.push(`color-${this.color}-border`, 'has-line');
        }
        if (this.subtitle) {
            cls.push('mb-3');
        }
        if (!this.subtitle) {
            cls.push('mb-0');
        }
        return cls;
    }

    /**
     * Attribute to bind to the rogue
     *
     * @returns {object}
     */
    get attr(): object {
        const link: { [k: string]: string | object } = {};
        if (this.getValue('link')) {
            const type = typeof this.getValue('link');
            if (type === 'string') {
                link.href = this.getValue('link');
            } else {
                link.to = { ...this.getValue('link'), params: { id: this.getValue('id') } };
            }
        }
        return link;
    }
}
